import Types from 'constants/types';

/**
 * Check fields pass constraints, and if not, construct
 * message to be displayed for user (and why validation failed)
 * @param {*} field Edited field
 */
export const validateField = (field) => {
  const { values, props, type, label } = field;
  
  if (props === undefined) {
    return { isValid: true };
  }

  const { minOccurs, max, min } = props;
  const errorMsg = msg => `${label}: ${msg}`;
  const noValue = values.length === 0 || values[0] === '' || 
  typeof values[0] === 'object' && !values[0].uri;

  if (field.required || minOccurs > 0) {
    if (noValue) {
      return { isValid: false, message: errorMsg('pakollinen') };
    }
  }

  if (!noValue) {
    if (max) {
      for (let value of values) {
        if (value !== '' && parseInt(value) > parseInt(max)) {
          return { isValid: false, message: errorMsg('arvo liian suuri') };
        }
      }
    }
    if (min) {
      for (let value of values) {
        if (value !== '' && parseInt(value) < parseInt(min)) {
          return { isValid: false, message: errorMsg('arvo liian pieni') };
        }
      }
    }
  }

  else if (type === Types.RDF.RESOURCE) {
    for (let value of values) {
      if (!value.uri || value.uri === '') {
        return { isValid: false, message: errorMsg('viallinen arvo') };
      }
    }
  }

  return { isValid: true };
};

export const validateFields = (fields) => {
  const invalidFields = [];

  for (let field of fields) {
    const { isValid, message } = validateField(field);
    if (!isValid) {
      invalidFields.push(message);
    }
  }

  return invalidFields;
};